export default __webpack_public_path__ + "static/P_SearchThumb_IN-Wx-4556228075f3aa1d3769f59346d080ac.webp";